<div class="d-flex jc-center ai-center">
  <button mat-flat-button color="accent" class="export-button" (click)="export()" [disabled]="isExporting">
    <mat-icon>download</mat-icon>
    Export
    <mat-progress-bar color="accent" class="progress-bar" *ngIf="isExporting" mode="indeterminate"></mat-progress-bar>
  </button>
</div>
